import { toPascalCase } from './util/util'
import './css/app.css'

const vueCache = {}

const getVueComponents = () => {
  if (!Object.keys(vueCache).length) {
    const req = require.context('./components', true, /\.vue$/)

    req.keys().forEach(filename => {
      const name = filename.split('/').pop().replace(/\.vue$/, '')
      const Component = req(filename).default
      const tag = toPascalCase(name)

      if (Object.getPrototypeOf(Component).getClassName && Object.getPrototypeOf(Component).getClassName() === 'Component') {
        return
      }

      vueCache[tag] = Component
    })
  }

  return vueCache
}

export default {
  install: (app, options) => {
    // setup variables
    app.config.globalProperties.$config = options
    const components = getVueComponents()
    if (components && Object.keys(components).length) {
      Object.keys(components).map(name => {
        return app.component(name, components[name])
      })
    }
  }
}
